/*
  KP: keeps the theme's cart numbers in step with the Rebuy cart.

  When something is removed (or its quantity changed) inside the Rebuy cart, the theme is not
  told, so the number on the cart icon in the header and the little counts on the product
  tiles stayed as they were until the page was refreshed. This listens for Rebuy saying the
  cart has changed, asks the store what is in the cart now, and then:
    - sets the count on every product tile on the page, and
    - redraws the cart icon in the header (only when the number of items has changed).

  It also listens for "kp:cart.change", which our own scripts send after adding to the cart
  themselves (the "+ Add" buttons of the accessories panel, assets/kp-addons.js).

  It does not open, close or change either cart. Loaded by snippets/theme-globals.liquid.
  Not needed if Rebuy's cart is ever removed.
*/
(function () {
  'use strict';

  var HEADER_CARTS = ['.header__content-mobile [data-header-cart]', '.header__content-desktop [data-header-cart]'];
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var timer = null;
  var lastCount = null;

  function each(list, action) {
    for (var i = 0; i < list.length; i++) action(list[i]);
  }

  // The same things the theme changes on a tile when its own cart changes.
  function updateTiles(cart) {
    each(document.querySelectorAll('.product-item[data-id]'), function (tile) {
      var id = tile.dataset.id;
      var count = 0;
      each(cart.items || [], function (line) {
        if (String(line.product_id) === String(id)) count += line.quantity;
      });

      if (String(tile.dataset.quantityInCart) === String(count)) return;

      tile.dataset.quantityInCart = count;
      each(tile.querySelectorAll('[data-quantity-in-cart]'), function (element) {
        element.dataset.quantityInCart = count;
      });
      each(tile.querySelectorAll('.quantity-in-cart-display[data-id="' + id + '"]'), function (element) {
        element.textContent = count;
      });
      each(tile.querySelectorAll('.quantity-input-wrapper--product-item-quick-add input'), function (input) {
        input.value = count;
      });
      if (count === 0) {
        each(tile.querySelectorAll('.product-item__quick-add-wrapper'), function (wrapper) {
          wrapper.classList.remove('active');
        });
      }
    });
  }

  // Ask the store for the header as it should look now, and copy its cart icon into the page.
  function updateHeader() {
    var link = document.querySelector('[data-header-cart]');
    var section = link ? link.closest('.shopify-section') : null;
    if (!section || !section.id) return;

    var id = section.id.replace('shopify-section-', '');
    fetch(root + '?section_id=' + encodeURIComponent(id))
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (html) {
        if (!html) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html');
        each(HEADER_CARTS, function (selector) {
          var from = fresh.querySelector(selector);
          var to = document.querySelector(selector);
          if (from && to && to.innerHTML !== from.innerHTML) to.innerHTML = from.innerHTML;
        });
      })
      .catch(function () {});
  }

  function sync() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateTiles(cart);
        if (cart.item_count !== lastCount) {
          lastCount = cart.item_count;
          updateHeader();
        }
      })
      .catch(function () {});
  }

  // Several of these can arrive together for one change; wait a moment and do the work once.
  function later() {
    clearTimeout(timer);
    timer = setTimeout(sync, 250);
  }

  each(
    [
      'rebuy:cart.change',
      'rebuy:smartcart.line-item-removed',
      'rebuy:smartcart.line-item-increase',
      'rebuy:smartcart.line-item-decrease',
      'rebuy:smartcart.hide',
      'kp:cart.change'
    ],
    function (name) {
      document.addEventListener(name, later);
    }
  );
})();
